export default __webpack_public_path__ + "static/media/khoper.99847b11.svg";